import { inject,Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CustomerSupportToken, GenerateCustomerSupportTokenInput, GraphDotnetService, graphql, MediaclipMutationGenerateCustomerSupportTokenArgs } from 'app/shared/graph';

@Injectable({ providedIn: 'root' })
export class HubTokenService {
    private readonly graphDotnetService = inject(GraphDotnetService);


    generateCustomerSupportToken(
        input: GenerateCustomerSupportTokenInput
    ): Observable<CustomerSupportToken> {
        return this.graphDotnetService.mutate<MediaclipMutationGenerateCustomerSupportTokenArgs>(graphql`
                mutation generateCustomerSupportToken($input: GenerateCustomerSupportTokenInput!) {
                    generateCustomerSupportToken(input: $input) {
                        token
                        scheme
                    }
                }
            `,
            { input }
        ).pipe(map((result) => result.generateCustomerSupportToken));
    }
}
